import { render } from "./scrollbar.vue?vue&type=template&id=3252c7cd"
import script from "./scrollbar.vue?vue&type=script&lang=js"
export * from "./scrollbar.vue?vue&type=script&lang=js"

import "./scrollbar.vue?vue&type=style&index=0&id=3252c7cd&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__